<div class="navigationMenuContainer">
	<button class="navigationMenuButton" [matMenuTriggerFor]="navigationMenu">
		<i class="fa fa-lg fa-bars"></i>
	</button>
	<mat-menu #navigationMenu="matMenu" xPosition="before" class="navigationMenuPanel">
		<ng-template *ngIf="portail === 'user'" matMenuContent let-item="item">
			<a
				mat-menu-item
				class="navigationActionButton"
				ui-sref="root.home"
				title="Accueil"
				(click)="navigateToAccueil()"
				>
				<i class="fa  fa-dashboard fa-fw"></i> Accueil
			</a>
			<a *ngFor="let entry of userOptions"
				mat-menu-item
				class="navigationActionButton"
				[title]="entry.title"
				[routerLink]="entry.path"
				routerLinkActive="active-link"
				>
				<i [class]="entry.icon"></i> {{ entry.label }}
			</a>
		</ng-template>
		<ng-template *ngIf="portail === 'admin'" matMenuContent let-item="item">
			<a
				mat-menu-item
				class="navigationActionButton"
				ui-sref="root.home"
				title="Accueil"
				(click)="navigateToAccueil()"
				>
				<i class="fa  fa-dashboard fa-fw"></i> Accueil
			</a>
			<a *ngFor="let entry of adminOptions"
				mat-menu-item
				class="navigationActionButton"
				[title]="entry.title"
				[routerLink]="entry.path"
				routerLinkActive="active-link"
				>
				<i [class]="entry.icon"></i> {{ entry.label }}
			</a>
		</ng-template>
	</mat-menu>
	<span class="app-title">AURORA</span>
</div>